/*
 * @Descripttion:
 * @Author: Junteng Shi
 * @Date: 2023-11-21 14:27:26
 * @LastEditors: Junteng Shi
 * @LastEditTime: 2025-03-28 10:25:10
 */
import router from '@/router';
import { useAppStore } from '@/store';
export default function (app: any) {
  app.config.globalProperties.$checkPer = (value: string | any[]) => {
    // const permissionBtns = ['edit', 'delete', 'submit', 'publish'];
    const permissionBtns = <string[]>router.currentRoute.value.meta.permission || [];
    // const appStore = useAppStore();
    // const permissionBtns = appStore.rightsArr;

    const status: boolean = permissionBtns.some((item) => item == value);
    console.log('是否有权限', status);

    return status;
  };
}
